/**
 * Тона бейджа статуса посева.
 *
 * AK-434: ПОДПИСИ здесь больше не живут — их даёт единый словарь
 * `SOWING_STAGE_LABELS` из `@/lib/sowings/stage`, тот же, что рисует полосу
 * прогресса и попап карты. Раньше словарей было два, и на ОДНОМ экране
 * (вкладка «Посевы») бейдж говорил «Незапланировано», а полоса под ним —
 * «План»; на здоровых записях расходились «Запланирован»/«План»,
 * «Растёт»/«Вегетация», «Частично убран»/«Убирают». Здесь остаётся только то,
 * чего в словаре этапов нет и быть не должно: тонировка и легаси-код `fallow`.
 *
 * Цвета — Earth Tech семантические токены / shadcn Badge variant.
 */
import { SOWING_STAGE_LABELS } from '@/lib/sowings/stage';

export interface SowingStatusInfo {
  label: string;
  /** className для <Badge> — тонировка ближе к AntD-эквиваленту. */
  className: string;
}

/** Тон бейджа по коду статуса. Ключи = полный словарь кодов бейджа. */
const STATUS_TONES: Record<string, string> = {
  unplanned: 'bg-muted text-muted-foreground',
  planned: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  sown: 'bg-indigo-100 text-indigo-800 hover:bg-indigo-100',
  growing: 'bg-primary/15 text-primary hover:bg-primary/15',
  partial_harvest: 'bg-lime-100 text-lime-800 hover:bg-lime-100',
  harvested: 'bg-muted text-muted-foreground',
  // Вычисляемые коды (ADR-055 D2): бейдж теперь получает РАЗРЕШЁННЫЙ статус,
  // поэтому они сюда доезжают. Без тона getSowingStatusInfo вернул бы сам код —
  // и на экране оказался бы `partial_sown`.
  partial_sown: 'bg-indigo-100 text-indigo-800 hover:bg-indigo-100',
  written_off: 'bg-destructive/10 text-destructive hover:bg-destructive/10',
  plowed_under: 'bg-muted text-muted-foreground',
  failed: 'bg-destructive/10 text-destructive hover:bg-destructive/10',
  reseeded: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
  closed: 'bg-muted text-muted-foreground',
  fallow: 'bg-accent/20 text-accent-foreground hover:bg-accent/20',
  finished: 'bg-muted text-muted-foreground',
};

/**
 * `fallow` — легаси-код статуса (ADR-046 убрал пар из статуса в
 * `field_state_id`), в лестницу этапов он не входит, поэтому подпись своя.
 */
const EXTRA_LABELS: Record<string, string> = { fallow: 'Парует' };

export const SOWING_STATUS_RU: Record<string, SowingStatusInfo> = Object.fromEntries(
  Object.entries(STATUS_TONES).map(([code, className]) => [
    code,
    { label: EXTRA_LABELS[code] ?? SOWING_STAGE_LABELS[code] ?? code, className },
  ]),
);

export function getSowingStatusInfo(code: string | null | undefined): SowingStatusInfo | null {
  if (!code) return null;
  return SOWING_STATUS_RU[code] ?? { label: code, className: 'bg-muted text-muted-foreground' };
}
